import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import he from "./he.json"
import en from "./en.json"

const resources = {
    en: {
        translation: { ...en }
    },
    he: {
        translation: { ...he }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'he',
        keySeparator: false,
        fallbackLng: "he",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;